import { CustomizedTypography, Stack, VStack } from '@components/Customized';
import { CapaErrorCode } from '@generated/graphql';
import { bankMap } from '@utils/bankMap';
import { processEvents } from '@utils/customEvent';
import { useSnackbar } from 'notistack';
import { useMemo } from 'react';
import { ProgressInfoBottomItemCommonProps } from './types';

const ProcessPayment = ({
  payment,
  matches
}: ProgressInfoBottomItemCommonProps) => {
  const { enqueueSnackbar } = useSnackbar();
  const Container = useMemo(() => (matches ? VStack : Stack), [matches]);
  const bankCode = payment?.virtualAccount?.bankCode ?? undefined;
  const totalAmount = (payment?.totalAmount ?? 0).toLocaleString('ko-kr');
  const bankAccount = payment?.virtualAccount?.accountNumber ?? '';
  const accountHolder = payment?.virtualAccount?.bankHolder;

  const onClickAccount = async () => {
    const result = await processEvents.계좌번호복사({
      bankAccount
    });

    if (result.result === CapaErrorCode.Success) {
      enqueueSnackbar('계좌번호를 복사했습니다');
    } else {
      enqueueSnackbar('계좌번호 복사에 실패했습니다', { variant: 'warning' });
    }
  };

  return (
    <Container justifyContent="space-between" gap={16}>
      <VStack>
        <CustomizedTypography variant="body2" fontWeight="500">
          {accountHolder ?? '(주)에이팀벤처스'}
        </CustomizedTypography>

        <Stack gap={2} alignItems="center">
          <CustomizedTypography variant="body2">
            {bankMap(bankCode)}
          </CustomizedTypography>
          <CustomizedTypography
            onClick={onClickAccount}
            variant="body2"
            color="textSecondary"
            style={{ textDecoration: 'underline', cursor: 'pointer' }}
          >
            {bankAccount}
          </CustomizedTypography>
        </Stack>
      </VStack>
      <VStack>
        <CustomizedTypography variant="subtitle2" color="textSecondary">
          입금 요청금액
        </CustomizedTypography>
        <CustomizedTypography
          variant="body2"
          fontWeight="500"
          align={matches ? 'left' : 'right'}
        >
          {totalAmount}원
        </CustomizedTypography>
      </VStack>
    </Container>
  );
};

export default ProcessPayment;
